const configuredSiteUrl = process.env.REACT_APP_SITE_URL?.trim();

export function getAuthRedirectBaseUrl(): string {
  if (configuredSiteUrl) {
    return configuredSiteUrl.replace(/\/$/, '');
  }

  return window.location.origin;
}

export function buildAuthRedirectPath(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${getAuthRedirectBaseUrl()}${normalizedPath}`;
}
